export default __webpack_public_path__ + "static/media/project3.91f776b5.png";